module.exports = __webpack_public_path__ + "img/twbg_icon.0808a00e.png";